// Note, all send and receive functions are extended in the asWindow HOC
// to simplify use from windows. This allows sender to automatically be added
// for sending and recipient to be automatically added for receiving
export function sendWindowMessage(
  recipient,
  payload,
  sender = null,
  config = {}
) {
  return {
    type: 'SEND_WINDOW_MESSAGE',
    message: payload,
    recipient,
    timestamp: Date.now(),
    sender,
    config
  }
}
export function markWindowMessageReceived(windowName) {
  return {
    type: 'MARK_WINDOW_MESSAGE_RECEIVED',
    recipient: windowName
  }
}

export function markAllWindowMessageReceived(windowName) {
  return {
    type: 'MARK_ALL_WINDOW_MESSAGES_RECEIVED',
    recipient: windowName
  }
}

export function clearWindowMessageQueue(windowName) {
  return {
    type: 'CLEAR_WINDOW_MESSAGE_QUEUE',
    recipient: windowName
  }
}
